<template>

    <div class="publication__editor content-width">

        <div class="publication__editor-wrap  d-flex">
            <div class="publication__editor-item">
                <div class="publication__fieldset">
                    <div class="publication__fieldset-title">{{$store.getters.t('publication_pet_preview_pet_name')}}</div>
                    <div class="publication__fieldset-input">
                        <input type="text" v-model="$v.name.$model" :placeholder="$store.getters.t('publication_pet_preview_enter_pet_name')">
                    </div>
                    <div class="text-danger" v-show="$v.name.$error">{{$store.getters.t('publication_pet_preview_invalid_value')}}</div>
                </div>
                <div class="publication__fieldset publication__fieldset--textarea-medium">
                    <div class="publication__fieldset-title">{{$store.getters.t('publication_pet_preview_catalog_subtitle')}}</div>
                    <div class="publication__fieldset-input">
                        <textarea v-model="$v.ad_title.$model" :placeholder="$store.getters.t('publication_pet_preview_enter_catalog_text')"></textarea>
                    </div>
                    <div class="text-danger" v-show="$v.ad_title.$error">{{$store.getters.t('publication_pet_preview_invalid_value')}}</div>
                </div>
                <div class="publication__fieldset publication__fieldset--textarea-large" v-if="provideStep === server.idx">
                    <div class="publication__fieldset-title">{{$store.getters.t('publication_pet_preview_pet_info')}}</div>
                    <quill-editor
                        class="publication__fieldset-input"
                        v-model="$v.description.$model"
                        :options="editorOption"
                    />
                    <div class="text-danger" v-show="$v.description.$error">{{$store.getters.t('publication_pet_preview_invalid_value')}}</div>
                </div>
            </div>
            <div class="publication__editor-item d-flex">
                <div class="publication__fieldset d-flex">
                    <div class="publication__fieldset-title">
                        {{$store.getters.t('publication_preview_title')}}
                    </div>
                    <div class="publication__fieldset-placeholder d-flex">
                        <div class="publication__fieldset-placeholder-card">

                            <div class="publication__fieldset-placeholder-avatar">
                                <img src="" alt="">
                            </div>

                            <div class="publication__fieldset-placeholder-title d-flex">
                                <div class="publication__fieldset-placeholder-name">{{ name || $store.getters.t('publication_pet_preview_enter_pet_name') }}</div>
                                <div class="publication__fieldset-placeholder-location">
                                    <span class="lnr lnr-map-marker"></span>
                                    {{selectedCity.name}}
                                </div>
                            </div>

                            <div class="publication__fieldset-placeholder-description">{{ ad_title || $store.getters.t('publication_pet_preview_enter_catalog_text') }}</div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>

import { quillEditor } from 'vue-quill-editor';

import { required, maxLength } from 'vuelidate/lib/validators';
import StateMixin from "../mixins/StateMixin";

export default {
    name: "PublicationPreview",
    props: ['server'],
    inject: ['step'],
    mixins: [StateMixin],
    components: { quillEditor },
    data(){
        return{
            editorOption: {
                modules: {
                    toolbar: [['bold', 'italic', 'underline','blockquote'],[{ 'list': 'ordered'}, { 'list': 'bullet' }]]
                },
                placeholder: this.$store.getters.t('publication_pet_preview_enter_common_text'),
                theme: 'snow'
            },
        }
    },
    computed:{
        provideStep(){
            return this.step();
        },
        name: {
            get() { return this.GET_BY_KEY('name') },
            set( val ) {
                this.SET_PET_BY_KEY({key: 'name', data: val})
            }
        },

        ad_title: {
            get() { return this.GET_BY_KEY('ad_title') },
            set( val ) {
                this.SET_PET_BY_KEY({key: 'ad_title', data: val})
            }
        },

        description: {
            get() { return this.GET_BY_KEY('description') },
            set( val ) {
                this.SET_PET_BY_KEY({key: 'description', data: val})
            }
        },

        selectedCity(){ return this.GET_BY_KEY('selectedCity') },

    },

    methods:{

        isValid(){
            this.$v.$touch();

            if( this.$v.$invalid ){
                this.$emit('parent-update', false );
                return false
            }

            this.$emit('parent-update', true )
            return true

        }
    },

    validations: {
        name:        { required },
        ad_title:    { required, maxLength: maxLength(80) },
        description: { required, maxLength: maxLength(3000) },
    }

}
</script>

<style scoped>

</style>
